/* eslint-disable @eslint-react/no-unstable-default-props */
/* eslint-disable @typescript-eslint/no-use-before-define */
import type { FC, JSX } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { SideNavItem } from './side-nav-item';

export interface Item {
  title: string;
  id: number;
  route: string | null;
  icon: string | null; // Allow icon to be null
  parent_menu_id: number | null;
  orders: number;
  is_menu: boolean;
  created: string;
  items?: Item[];
}

const renderItems = ({
  depth = 0,
  items,
  pathname,
  collapsed,
}: {
  depth?: number;
  items: Item[];
  pathname?: string | null;
  collapsed?: boolean;
}): JSX.Element[] =>
  items.reduce(
    (acc: JSX.Element[], item) =>
      reduceChildRoutes({
        acc,
        depth,
        item,
        pathname,
        collapsed,
      }),
    [],
  );

const reduceChildRoutes = ({
  acc,
  depth,
  item,
  pathname,
  collapsed,
}: {
  acc: JSX.Element[];
  depth: number;
  item: Item;
  pathname?: string | null;
  collapsed?: boolean;
}): JSX.Element[] => {
  const checkPath = !!(item.route && pathname);
  const partialMatch = checkPath ? pathname.includes(item.route ?? '') : false;
  const exactMatch = checkPath ? pathname === item.route : false;
  if (item.items && item.items.filter(menu => menu.is_menu).length > 0) {
    acc.push(
      <SideNavItem
        active={partialMatch}
        depth={depth}
        collapsed={collapsed}
        // disabled={item.disabled}
        key={item.title}
        label={item.title}
        title={item.title}
        icon={item.icon}
        open={partialMatch}
      >
        <Stack
          spacing={0.5}
          component="ul"
          sx={{
            listStyle: 'none',
            m: 0,
            p: 0,
          }}
        >
          {item.is_menu &&
            renderItems({
              depth: depth + 1,
              items: item.items,
              pathname,
              collapsed,
            })}
        </Stack>
      </SideNavItem>,
    );
  } else if (item.is_menu) {
    acc.push(
      <SideNavItem
        active={exactMatch}
        depth={depth}
        collapsed={collapsed}
        // disabled={item.disabled}
        // external={item.external}
        key={item.title}
        label={item.title}
        title={item.title}
        icon={item.icon}
        route={item.route}
      />,
    );
  }

  return acc;
};

interface SideNavSectionProps {
  items?: Item[];
  pathname?: string | null;
  subheader?: string;
  subheaderIcon?: string;
  collapsed?: boolean;
}

export const SideNavSection: FC<SideNavSectionProps> = props => {
  const {
    items = [],
    pathname,
    subheader = '',
    collapsed = false,
    ...other
  } = props;
  return (
    <Stack
      spacing={0.5}
      component="ul"
      sx={{
        listStyle: 'none',
        m: 0,
        p: 0,
      }}
      {...other}
    >
      {subheader && !collapsed && (
        <Box
          component="li"
          sx={{
            color: 'var(--nav-section-title-color)',
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1.66,
            mb: 1,
            ml: 1,
            display: 'flex',
            alignItems: 'center',
            textTransform: 'uppercase',
          }}
        >
          {subheader}
        </Box>
      )}
      {renderItems({
        items: items.filter(menu => menu.is_menu),
        pathname,
        collapsed,
      })}
    </Stack>
  );
};
